<template>
    <div>
        <app-navigation/>
        <app-banner
          backgroundUrl="/press/logos/IndiaGranularMap.png"
          :headerButtons="headerButtons"
          backgroundSize="cover"
          backgroundPosition="0% 20%"
          title='"A scenario-based workshop of a high consequence pathogen epidemic": interactive workshop and tabletop exercise, India, 2026'
        />
        <div style="background-color: #e6e8e8;">
        <div style="text-align: left; min-height: 50vh; margin-left: 10%; margin-right: 10%; padding: 5vh;">
            <div>
                <h2>EPIWATCH, UNSW and the National Institute for Epidemiology, India, will be holding a workshop in Delhi, India in 2026:</h2>
                <br/>
            </div>
            <div>
                <h1>A scenario-based workshop of a high consequence pandemic</h1>
                <br/>
            </div>
            <div>
                May 26-27, 2026
                <br/><br/>
            </div>
            <div>
                <b>Background: </b>Epidemics and major biological incidents are characterised by complexity, uncertainty, rapid evolution, lack of available time, societal systems stress and degradation, and extreme demands on resources and individuals. Key decision makers are asked to work in this environment and make the best decisions for the populations for which they are responsible. Decision makers – ranging from first responders across health, law enforcement, defence and other agencies, through to strategic decision makers – are often confronted with operational dilemmas and trade-offs where no clearly superior course of action exists. The decision landscape becomes additionally complex where events cross international jurisdictions and concerns. In such situations, both local and international legislation, approaches, norms, culture, medical capability, broader emergency response capability, and broader social and security support structures render decision making more difficult. This is particularly relevant to India and Asia where there is a wide variety of geography, health and epidemic response resources, social resources, wealth, and varying levels of expertise in epidemic response situations. <b>The role of digital technology and AI is also critical, and will be explored using the EPIWATCH AI system.</b> The kinds of factors important to decision makers and epidemic response personnel to identify, analyse, develop and decide on courses of action during epidemic response scenarios is not well understood.
                <br/><br/>
                 The EPIWATCH team from UNSW will lead the design and execution of the workshop. From the Indian side, this workshop will be jointly coordinated by the Communicable Diseases Division of The Indian Council of Medical Research (ICMR) and the National Institute for Epidemiology (ICMR-NIE), Chennai, the leading government agency for infectious diseases epidemiology. 
                <br/><br/>
                </div>
            <div>
                <b>Workshop Format:</b> The two-day educational workshop will combine an interactive scenario of a simulated pandemic with expert lectures and discussion, held in Delhi. NIE and ICMR will invite key stakeholders across India and arrange guest speakers. EPIWATCH and UNSW will provide the scenario design and multimedia based on a long track record of running immersive scenarios. The scenario will be underpinned by mathematical modelling of disease transmission, and supported by multimedia such as video and radio news clips for an immersive experience. EPIWATCH, an advanced AI system for epidemic intelligence, will be featured. A workshop report will be produced.
                <br/><br/>
            </div>
            <div>
                <b>Workshop Facilitators:</b> <a href="https://research.unsw.edu.au/people/professor-raina-macintyre">Professor Raina MacIntyre</a> (EPIWATCH® and UNSW), <a href="https://www.unsw.edu.au/staff/david-heslop">Associate Profressor David Heslop</a> (UNSW), <a href="https://www.tephinet.org/manoj-murhekar">Dr Manoj Murhekar</a> (Director, NIE India)
            </div>
        </div>
        </div>
      <app-footer/>
    </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/AppNavigation.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppBanner from '@/components/AppBanner.vue'

export default {
  name: 'IndiaWorkshop',
  components: {
      AppNavigation,
      AppFooter,
      AppBanner
  },
  data: () => ({
    headerButtons: [],
  })
}
</script>